import { isProd } from "../api/config";

export const LANDING_URL = isProd() ? "https://letsmeet.network" : '/';
export const MAX_INVITEES_LEGIT_TO_DISPLAY = 5;